export default "/static/95cdfcd86d9ace81.svg"